import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import CallingDesk from './pages/CallingDesk';
import Tasks from './pages/Tasks';
import Users from './pages/Users';
import CallingData from './pages/CallingData';
import Attendance from './pages/Attendance';
import Demos from './pages/Demos';
import FollowUps from './pages/FollowUps';
import Reports from './pages/Reports';
import Announcements from './pages/Announcements';
import Pipeline from './pages/Pipeline';
import Leaves from './pages/Leaves';
import Wallet from './pages/Wallet';
import Issues from './pages/Issues';

function PrivateRoute({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#6366f1' }}>Loading...</div>;
  if (!user) return <Navigate to="/login" />;
  if (adminOnly && user.role !== 'superadmin') return <Navigate to="/" />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="calling" element={<CallingDesk />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="demos" element={<Demos />} />
        <Route path="attendance" element={<Attendance />} />
        <Route path="followups" element={<FollowUps />} />
        <Route path="pipeline" element={<Pipeline />} />
        <Route path="leaves" element={<Leaves />} />
        <Route path="wallet" element={<Wallet />} />
        <Route path="issues" element={<Issues />} />
        <Route path="users" element={<PrivateRoute adminOnly><Users /></PrivateRoute>} />
        <Route path="calling-data" element={<PrivateRoute adminOnly><CallingData /></PrivateRoute>} />
        <Route path="reports" element={<PrivateRoute adminOnly><Reports /></PrivateRoute>} />
        <Route path="announcements" element={<PrivateRoute adminOnly><Announcements /></PrivateRoute>} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ style: { background: '#1a1d27', color: '#e2e8f0', border: '1px solid #2d3148' } }} />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
